import { render, staticRenderFns } from "./DatosIncendio.vue?vue&type=template&id=4fdadb14&scoped=true"
import script from "./DatosIncendio.vue?vue&type=script&lang=js"
export * from "./DatosIncendio.vue?vue&type=script&lang=js"
import style0 from "./DatosIncendio.vue?vue&type=style&index=0&id=4fdadb14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdadb14",
  null
  
)

export default component.exports